/**
 * Resolves a public asset against Vite's deployment base path.
 *
 * @param {string} path
 * @param {{ cacheBust?: boolean }} options
 */
export function assetUrl(path, { cacheBust = false } = {}) {
  const normalizedPath = path.replace(/^\/+/, "");
  const url = `${import.meta.env.BASE_URL}${normalizedPath}`;

  return cacheBust ? `${url}?t=${Date.now()}` : url;
}
